import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const HTTP_PROTOCOL_PATTERN = /^https?:\/\//i;
const EXPLICIT_PROTOCOL_PATTERN = /^[a-z][a-z\d+.-]*:\/\//i;
const DOMAIN_PATTERN = /^(?=.{1,253}$)(?:[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?\.)+[a-z]{2,63}$/i;

export const optionalWebsiteUrlValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
  isValidWebsiteUrl(control.value) ? null : { pattern: true };

export function normalizeWebsiteUrl(value?: string | null): string {
  const trimmedValue = value?.trim() || '';

  if (!trimmedValue || HTTP_PROTOCOL_PATTERN.test(trimmedValue)) {
    return trimmedValue;
  }

  return `https://${trimmedValue}`;
}

export function isValidWebsiteUrl(value: unknown): boolean {
  if (value === null || value === undefined || value === '') {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return true;
  }

  if (/\s/.test(trimmedValue)) {
    return false;
  }

  if (EXPLICIT_PROTOCOL_PATTERN.test(trimmedValue) && !HTTP_PROTOCOL_PATTERN.test(trimmedValue)) {
    return false;
  }

  try {
    const url = new URL(normalizeWebsiteUrl(trimmedValue));

    return (
      (url.protocol === 'http:' || url.protocol === 'https:') &&
      !url.username &&
      !url.password &&
      DOMAIN_PATTERN.test(url.hostname)
    );
  } catch {
    return false;
  }
}
